import React from "react";

const CheckIns = () => <div />;
export default CheckIns;
